import chroma_js from "chroma-js";
import {Bridge, E, IsNaN, IsObject, SleepAsync, ToJSON_Advanced, ToNumber} from "js-vextensions";
import {HandleError} from "web-vcore";
import {liveSession} from "../../Engine/LiveSessionManagement.js";
import {HSBK2RGB} from "../../Utils/General/Colors.js";
import {PluginGeneral} from "../Capacitor/GeneralPlugin.js";
import {NodeBridge_AddChannelMessageReceiver, NodeBridge_SendChannelMessage} from "./Bridge_Preload.js";
import {GetStore_Late} from "../../Store/@LateAccess.js";
import {Capacitor} from "@capacitor/core";

export function InWeb(allowURLFlagToModify: 0 | 1) {
	return !InDesktop() && !InAndroid(allowURLFlagToModify);
}
export function InNativeApp(allowURLFlagToModify: 0 | 1) {
	return InDesktop() || InAndroid(allowURLFlagToModify);
}

export function InDesktop() {
	return inElectron && !InAndroid(0);
	//return g.Capacitor.getPlatform() == "electron";
}
//let inAndroid: boolean;
export function InAndroid(allowURLFlagToModify: 0 | 1) {
	/*inAndroid = false;
	(async()=>{
		try {
			await Plugins["General"].Test1();
			// if not in android, we won't reach this, since the call above will immediately error ("no web implementation")
			inAndroid = true;
		} catch (error) {
			console.log("Apparently not in Android. Got error when trying to call Test1: ", error);
		}
	})();*/
	//inAndroid = g.Capacitor != null;
	//inAndroid = Plugins.Device.getInfo().[...];
	return Capacitor.getPlatform() == "android" || (!!allowURLFlagToModify && startURL.GetQueryVar("extra") == "android"); // flag is for debugging
}

export const nativeBridge = new Bridge({
	receiveChannelMessageFunc_adder: receiveChannelMessageFunc=>{
		if (!InNativeApp(0)) return;

		if (InDesktop()) {
			// function populated by Start_WebviewPreload.ts of lucid-frontier-desktop project
			NodeBridge_AddChannelMessageReceiver(channelMessage=>{
				receiveChannelMessageFunc(channelMessage);
			});
		} else {
			// function declared in General.java under "android/..."
			/*General["AddNativeMessageListener"](channelMessage=>{
				receiveChannelMessageFunc(channelMessage);
			});*/
			// this gets called by bridgeJS.sendChannelMessageFunc in General.kt
			window.addEventListener("BridgeNative_SendChannelMessage", channelMessage=>{
				receiveChannelMessageFunc(channelMessage);
			});
		}
	},
	sendChannelMessageFunc: async channelMessage=>{
		if (!InNativeApp(0)) return;

		// temp; to help debug OOM issue android had on logging a massive message sent from frontend to android, console.log() anything over 1000 characters
		// commented; issue does not seem to be occurring anymore (hasn't happened in months I believe)
		/*const channelMessageStr = typeof channelMessage == "string" ? channelMessage : ToJSON_Advanced(channelMessage, {trimDuplicates: true});
		if (channelMessageStr.length > 1000) {
			console.log("Sending large channel-message to native. @length:", channelMessageStr.length);
			await SleepAsync(500); // wait a bit, to give time for the above log to definitely be recorded in sentry
			console.log("@channelMessageStr:", channelMessageStr);
			console.log("@channelMessage:", channelMessage);
		} else {
			console.log("Sending small channel-message to native. @length:", channelMessageStr.length); // temp: do this as well for now (the above failed to catch cause of OOM case somehow!)
			console.log("@channelMessageStr:", channelMessageStr);
			//console.log("@channelMessage:", channelMessage);
		}*/

		if (InDesktop()) {
			// function populated by Start_WebviewPreload.ts of lucid-frontier-desktop project
			NodeBridge_SendChannelMessage(channelMessage);
		} else {
			// function declared in General.java under "android/..."
			PluginGeneral.SendToNative(channelMessage);
		}
	},
	channel_stringifyChannelMessageObj: false,
	requireMainFuncForCalls: false, // for, eg. NotifyVolumeKeyDown listener in RecordingPanel.tsx
});
nativeBridge.RegisterFunction("FromNode_HandleGlobalError", errorStr=>{
	HandleError(errorStr);
});

export function RunKasaCommand_LAN(funcName: string, commandObj?: object): Promise<any> {
	//console.log("Running Kasa LAN command: ", commandObj);
	/*const uiState = store.main.effects.lights;
	if (InDesktop()) {
		return RunKasaCommand_LAN_Desktop(funcName, argsObj, {ip: uiState.lifx_ipAddress, mac: uiState.lifx_macAddress});
	}*/
	return nativeBridge.Call("RunKasaCommand_LAN", commandObj) as Promise<any>;
}

// general Android stuff
// ==========

// if disabled, probably due to wanting to avoid memory-leaks, for if something keeps creating more timers (or if number just gets high enough, since timers aren't auto-removed from this list)
//	(another possible reason is: to make it more obvious when the keep-awake systems aren't working, since even if we make timers work, other stuff might not be working, like mic recording)
//TimerContext.default_autoAddAll = true;

// for this one function, we'll just use the capacitor bridge, since the js-vextensions Bridge has more overhead (eg. callback)
/*nativeBridge.RegisterFunction("WakeUp", pack=>{
	const {sendTime, lastNonZeroMicLoudness} = pack as any;
	//SessionLog(`Got WakeUp event! @SendDelay(${Date.now() - sendTime}) @LastNZMicLoudness(${lastNonZeroMicLoudness})`);
	TimerContext.default.ManuallyTriggerOverdueTimers();
});*/
window.addEventListener("WakeUp", event=>{
	const {sendTime, lastNonZeroMicLoudness} = event as any;
	//SessionLog(`Got WakeUp event! @SendDelay(${Date.now() - sendTime}) @LastNZMicLoudness(${lastNonZeroMicLoudness})`);
	//TimerContext.default.ManuallyTriggerOverdueTimers();
	//if (liveSession && InAndroid(0) && !screenOn) {
	if (liveSession && InAndroid(0)) {
		liveSession.timerContext.ManuallyTriggerOverdueTimers(1000); // QUESTION: Is 1-second a good threshold?
	}
});